import Colors from "../../../../../global/Colors";

export const TAB_STYLES = {
  TAB: {
    SX: {
      minHeight: 48,
      backgroundColor: Colors.white,
      borderRadius: "15px 15px 0 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      padding: "4px 5px 0 5px",
      "& .MuiTab-root": {
        color: Colors.black,
        fontWeight: 700,
        minWidth: 120,
        minHeight: 48,
        textTransform: "uppercase",
        backgroundColor: Colors.gray[100],
        borderRadius: "10px 10px 5px 5px",
        marginRight: "3px",
      },
      "& .MuiTab-root:last-of-type": {
        marginRight: 0,
      },
      "& .Mui-selected": {
        color: "#2566af",
        backgroundColor: "#d6e6fa",
      },
      "& .Mui-disabled": {
        color: Colors.gray[400],
        opacity: 0.5,
      },
    },
    TAB_INDICATOR_SX: { backgroundColor: "transparent" },
  },
  SUB_TAB: {
    SX: {
      minHeight: 48,
      backgroundColor: "#d6e6fa",
      margin: "0px 5px 0 5px",
      "& .MuiTab-root": {
        color: "#2566af",
        fontWeight: 600,
        minWidth: 120,
        minHeight: 48,
        borderBottom: "none",
        textTransform: "none",
      },
      "& .Mui-selected": {
        color: "#2566af",
        fontWeight: 700,
        borderBottom: "4px solid #2566af",
        backgroundColor: "transparent",
      },
      "& .Mui-disabled": {
        color: "#b0b0b0",
        opacity: 0.5,
      },
    },
    TAB_INDICATOR_SX: { backgroundColor: "transparent" },
  },
};
